export default {
  marginHorizontal: '4%',
  fontXS: {
    fontSize: '7px',
    lineHeight: 1.2,
  },
  fontS: { fontSize: '9px', lineHeight: 1.2 },
  fontM: { fontSize: '11px', lineHeight: 1.2 },
  fontL: { fontSize: '13px', lineHeight: 1.2 },
  fontXL: { fontSize: '18px', lineHeight: 1.2 },
  flexRow: {
    display: 'flex',
    flexDirection: 'row',
  },
  sectionTitle: {
    marginTop: 5,
    marginBottom: 5,
    marginHorizontal: 5,
    fontWeight: 'bold',
    fontSize: '7px',
    lineHeight: 1.2,
  },
  detailRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
};
